import clsx from "clsx";
import { PropsWithChildren } from "react";

import styles from "./ProductName.module.scss";
import HeadingText from "../support/HeadingText";

type ProductNameProps = PropsWithChildren<{
  className?: string;
  as?: "h1" | "h2" | "h3" | "p" | "span";
}>;

export default function ProductName({
  className,
  children,
  as = "p",
}: ProductNameProps) {
  const isWhiteLabeled = true;

  return (
    <HeadingText
      as={as}
      className={clsx(styles.productName, className, {
        [styles.whiteLabeled]: isWhiteLabeled,
      })}
    >
      {children}
    </HeadingText>
  );
}
